"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var react_1 = require("react");
var error_mark_svg_1 = __importDefault(require("../../../assets/wof/error_mark.svg"));
var WofErrorPopup = function (_a) {
    var type = _a.type, message = _a.message, onClose = _a.onClose;
    var containerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var timeout;
        if (containerRef.current) {
            containerRef.current.classList.add("wof-container--body-popup--show");
            timeout = setTimeout(handleClose, 2000);
        }
        return function () {
            if (timeout) {
                clearTimeout(timeout);
            }
        };
    }, []);
    var handleClose = function () {
        containerRef.current.classList.remove("wof-container--body-popup--show");
        setTimeout(onClose, 500);
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ ref: containerRef, className: (0, clsx_1.default)("wof-container--body-popup", {
            "wof-container--body-popup--success": type === "success",
            "wof-container--body-popup--error": type === "error",
        }) }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "wof-container--body-popup--mark" }, { children: (0, jsx_runtime_1.jsx)("img", { src: error_mark_svg_1.default, alt: "error_mark" }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "wof-container--body-popup--message" }, { children: message })), (0, jsx_runtime_1.jsx)("div", __assign({ onClick: handleClose, className: "wof-container--body-popup--close" }, { children: "\u00D7" }))] })));
};
exports.default = WofErrorPopup;
